import BaseModule from '@core/modules/base-module/base-module';
import LinksTabsNav from '@pj/components/links-tabs/links-tabs-nav/links-tabs-nav';
import $ from 'jquery';

let linksTabsNavArray = [];
const technologyTableModule = new BaseModule();
technologyTableModule.name = 'links-tabs';
technologyTableModule.init((that) => {
  that.elements.each(function () {
    const linksTabsNav = new LinksTabsNav($(this));
    linksTabsNav.init();
    linksTabsNavArray.push(linksTabsNav);
  })

});

technologyTableModule.onResize(() => {
  if (linksTabsNavArray.length>0) {
    linksTabsNavArray.forEach((elt) => {
      if (elt.isInit) {
        elt.resize();
      }
    });
  }
});
